import { useUser } from "@/composables/user";
import { createError404Link, router } from "@/router";
import { ApiClient } from "@/services/apiClient";
import { type OrderId } from "@/services/marketplace/order/orderTypes";
import { Purchase_Schema } from "@/services/marketplace/order/purchases/purchasesSchema";
import { type Purchase } from "@/services/marketplace/order/purchases/purchasesTypes";
import { assertUserIsLoggedIn } from "@/services/user";
import { handleAxiosError } from "@/utilities";
import { z } from "zod";

const ApiResponse_PurchaseList_Schema = z.object({
  orders: z.array(Purchase_Schema),
  // Not implemented yet
  //totalCount: WholeNumber_Schema,
});
type ApiResponse_PurchaseList = z.infer<typeof ApiResponse_PurchaseList_Schema>;

export const fetchPurchaseList = async (_page: number, _perPage: number): Promise<ApiResponse_PurchaseList> => {
  const { user } = useUser();
  assertUserIsLoggedIn(user.value);

  const url = "api/order/order";
  const query = { buyerUserId: user.value.id };
  return ApiClient.get<ApiResponse_PurchaseList>(url, query).then(({ data }) => ApiResponse_PurchaseList_Schema.parse(data));
};

export const fetchPurchase = async (id: OrderId): Promise<Purchase> => {
  const url = "api/order/order/" + id;
  return ApiClient.get<Purchase>(url)
    .then(({ data }) => Purchase_Schema.parse(data))
    .catch(handleAxiosError({ 403: () => router.replace(createError404Link()) }));
};

export const confirmOrderReceivedAndChecked = async (id: OrderId): Promise<Purchase> => {
  const url = "api/order/receive-order/" + id;
  return ApiClient.get<Purchase>(url)
    .then(({ data }) => Purchase_Schema.parse(data))
    .catch(handleAxiosError({ 403: () => router.replace(createError404Link()) }));
};
